import i18n from "./index";

export type PolicyLocale = {
  name: string;
  description: string;
};

// Thin compatibility wrapper around i18next.
// Reads from the "policies" namespace; falls back to caller-provided English.
// New callers should prefer `useTranslation("policies")` directly.
export const getPolicyLocale = (
  language: string,
  policyName: string,
  fallback: PolicyLocale,
): PolicyLocale => {
  const name = i18n.t(`${policyName}.name`, {
    ns: "policies",
    lng: language,
    defaultValue: fallback.name,
  });
  const description = i18n.t(`${policyName}.description`, {
    ns: "policies",
    lng: language,
    defaultValue: fallback.description,
  });
  return { name, description };
};
